import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  InputAdornment,
  IconButton,
  Grid,
  Paper,
  TextField,
  Typography,
  DialogActions
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import currency from "currency.js";
import AddIcon from "@mui/icons-material/Add";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import CloseIcon from "@mui/icons-material/Close";

export default function PricingVariant(props) {
  const { value } = props;

  const onChange = (mode, idx, data) => {
    const arr = [...value];

    if (mode === "add") {
      arr.push(data);
    } else if (mode === "edit") {
      arr[idx] = data;
    } else if (mode === "delete") {
      arr.splice(idx, 1);
    }
    props.onChange(arr);
  };

  return (
    <Box>
      <Box>
        <Grid container alignItems="center">
          <Grid item xs={9}>
            <Typography variant="h6">Variant Pricing</Typography>
          </Grid>
          <Grid item xs={3} align="right">
            <Entry mode="add" value="" onChange={(mode, data) => onChange(mode, 0, data)} />
          </Grid>
        </Grid>
      </Box>
      <Paper elevation={0}>
        <Box px={2} pt={4} pb={2}>
          {value &&
            Object.entries(value).map(([k, v], idx) => {
              return <Row key={k} idx={idx} variant={v} onChange={onChange} />;
            })}
          {value.length === 0 && (
            <Box px={2} py={4} align="center">
              <Typography variant="subtitle1">Add Variant</Typography>
              <Typography variant="body1" color="textSecondary">
                Click + to add one or more variants
              </Typography>
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
}

function Row(props) {
  const { idx, variant } = props;

  const onChange = (mode, data) => {
    props.onChange(mode, idx, data);
  };

  return (
    <Box mb={1}>
      <Box>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={9}>
            <Typography variant="body1">{variant.name}</Typography>
          </Grid>
          <Grid item xs={2} align="right">
            <Typography variant="body2">{currency(variant.pricing.amount).format()}</Typography>
          </Grid>
          <Grid item xs={1} align="right">
            <Entry mode="edit" variant={variant} onChange={onChange} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

function Entry(props) {
  const { variant, mode } = props;

  const [open, setOpen] = useState(false);

  const [size, setSize] = useState("");

  const [price, setPrice] = useState("");
  const [includeFees, setIncludeFees] = useState("");

  useEffect(() => {
    if (open) {
      setSize(variant?.name);
      setPrice(variant?.pricing?.amount || "");
      setIncludeFees(variant?.pricing?.includeFees || "");
    } else {
      reset();
    }
  }, [open]);

  const submit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    props.onChange(mode, { name: size, pricing: { type: "fixed", amount: currency(price).value } });
    setOpen(false);
    reset();
  };

  const handleDelete = () => {
    props.onChange("delete");
    setOpen(false);
    reset();
  };

  const reset = () => {
    setSize("");
    setPrice("");
  };

  return (
    <span>
      <IconButton size="small" onClick={() => setOpen(true)}>
        {mode === "edit" ? <EditOutlinedIcon /> : <AddIcon />}
      </IconButton>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
        <form onSubmit={submit}>
          <DialogTitle>
            Variant Details{" "}
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box pt={2}>
              <Grid container spacing={3}>
                <Grid item sm={12} xs={12}>
                  <TextField
                    id="size"
                    value={size}
                    label="Size"
                    name="size"
                    variant="outlined"
                    fullWidth
                    required
                    onChange={(e) => setSize(e.target.value)}
                    inputProps={{ maxLength: 40 }}
                    helperText="e.g. 6-inch (6-8 servings) / Single / Set of 12 / Small / Large, etc"
                  />
                </Grid>
                <Grid item sm={12} xs={12}>
                  <TextField
                    name="price"
                    value={price}
                    variant="outlined"
                    fullWidth
                    id="price"
                    label="Price"
                    onChange={(e) => setPrice(e.target.value)}
                    onWheel={(e) => {
                      e.target && e.target.blur();
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachMoneyOutlinedIcon />
                        </InputAdornment>
                      )
                    }}
                    type="number"
                    required
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            {mode === "edit" && (
              <Button fullWidth onClick={handleDelete} style={{ color: "#e74c3c" }}>
                Remove
              </Button>
            )}
            <Button fullWidth variant="contained" color="primary" type="submit">
              Confirm
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </span>
  );
}
